module.exports = __webpack_public_path__ + "img/products_big_can_pepper.5d7b6d45.png";